$(function(){
  console.log("-------");
  
  product_qunatity_updown();
  
  /* --- Slick-Slider --- */
  $('.px-csreview-slider-wrap').slick({
    dots: true,
    prevArrow: false,
    nextArrow: false,
    infinite: false,
    autoplay: false,
    draggable: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1240,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  
  /*------ Next/Previous Arrow ------*/
  $("#px-slide-leftarw").click(function(){
    $('.px-csreview-slider-wrap').slick('slickPrev');
  });
  $("#px-slide-rightarw").click(function(){
    $('.px-csreview-slider-wrap').slick('slickNext');
  });

  /* --- Scroll-Down --- */
  smoothScroll();
  
  
  /* --- Equal-box --- */
  var highestBox = 0 , i=1;
  $('.px-csreview-slider-wrap .px-csr-sldie').find('.px-csr-info p').each(function(){  
    if( $(this).height() > highestBox) {
      highestBox = $(this).height();
    }
    i++;
  });
  $('.px-csreview-slider-wrap .px-csr-sldie').find('.px-csr-info p').height(highestBox);

});


function product_qunatity_updown(){
	var zr_incrementval = 1;
	var zr_decrementval = 1;

	$(document).on('click', '#px-qty-plus', function(){
		var fetch_qtyval = parseInt($("#px-qty-text").val() );
		fetch_qtyval = fetch_qtyval + zr_incrementval;
		$("#px-qty-text").val(fetch_qtyval);
	});
	$(document).on('click', '#px-qty-minus', function(){
		var fetch_qtyval = parseInt($("#px-qty-text").val() );
		if(parseInt( $("#px-qty-text").attr("min") ) >= $("#px-qty-text").val() ){
			return false;
		}else{
			fetch_qtyval = fetch_qtyval - zr_incrementval;
			$("#px-qty-text").val(fetch_qtyval);
		}
	});
}

function smoothScroll(){
    $("a").on('click', function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
          // Prevent default anchor click behavior
          event.preventDefault();

          // Store hash
          var hash = this.hash;
          var scrolltopLen = $(hash).offset().top - 100;
          // Using jQuery's animate() method to add smooth page scroll
          // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
          $('html, body').animate({
            scrollTop: scrolltopLen
          }, 800, function(){

            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
          });
        } // End if
      });
}

